export const homeObjOne = {
    primary: true,
    lightBg: false,
    lightTopLine: true,
    lightText: true,
    lightTextDesc: true,
    topLine: 'Technology Agency',
    headline: 'YOUR TRUSTED TECHNOLOGY PROVIDER',
    description:
      'We help business owners increase their revenue. Our team of unique specialist can help you achieve your business goals.',
    buttonLabel: 'Nareebco',
    imgStart: '',
    img: require('../../images/svg-1.svg'),
    alt: 'Credit Card',
    start: ''
  };
  
  export const homeObjTwo = {
    primary: true,
    lightBg: false,
    lightTopLine: true,
    lightText: true,
    lightTextDesc: true,
    topLine: 'Instant Setup',
    headline: 'Extremely quick onboarding process',
    description:
      "Once you've joined, our team of specialist will reach out to you and get you set up in minutes.",
    buttonLabel: 'Learn More',
    imgStart: '',
    img: require('../../images/svg-2.svg'),
    alt: 'Vault',
    start: ''
  };
  
  export const homeObjThree = {
    primary: false,
    lightBg: true,
    lightTopLine: false,
    lightText: false,
    lightTextDesc: false,
    topLine: 'Nareebco   ',
    headline:
      'About Us      ',
    description:
      "Nareebco has had its humble beginning with a vision “engage people to enable technology into value”. We help you and your business connect with customers, integrate with vendors and empower employees to work to their fullest potential. Our committed teams have a unique blend of functional & operational knowledge, technical expertise and result-oriented management experience. We are women owned small company, proudly registered in Massachusetts. The people behind this business have been significant and they stand as the pillar of success.",
    buttonLabel: 'Nareebco',
    imgStart: 'start',
    img: require('../../images/profile.jpg'),
    alt: 'Vault',
    start: 'true'
  };
  
  export const homeObjFour = {
    primary: true,
    lightBg: false,
    lightTopLine: true,
    lightText: true,
    lightTextDesc: true,
    topLine: 'Secure Database',
    headline: 'All your data is stored on our secure server',
    description:
      'You will never have to worry about your information getting leaked. Our team of security experts will ensure your records are kept safe.',
    buttonLabel: 'Nareebco ',
    imgStart: 'start',
    img: require('../../images/svg-3.svg'),
    alt: 'Vault',
    start: 'true'
  };